export class TaxationDataDetails {
    taxCountry: string;
    taxNumberType: object;
    taxNumber: string;
}


// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/taxation-data/details/taxation-data-details.model.ts